import React from 'react';

// Bravo context strip (breadcrumb + chips row). The generated bravo-ds.css uses
// descendant selectors (.bravo-ds .context), so the scope class needs its own wrapper.
function ContextStrip({ children, className }) {
  return (
    <div className='bravo-ds'>
      <div className={className ? `context ${className}` : 'context'}>{children}</div>
    </div>
  );
}

export default ContextStrip;
